export default "__VITE_ASSET__BCChe2Vy__"